


















































































































































































import { Component, Vue } from "vue-property-decorator";
import ExpressionEditor from "@/components/ExpressionEditor.vue";
import { scrypt } from "crypto";
import { showKeyboard } from 'semantic-math-editor';
import {TabbedPanel, createDemo} from "matheditor-demo";

@Component({
  components: { ExpressionEditor }
})
export default class EditorTech extends Vue {
  demo: any;
  tabbedPanel: any;

  mounted() {
    const edEl = document.getElementById("matharia");
    const graphEl = document.getElementById("structureTree");
    const semEl = document.getElementById("logicTree");

    const n1 = document.getElementById("nav-human");
    const n2 = document.getElementById("nav-machine-j");
    const n3 = document.getElementById("nav-machine-l");
    const n4 = document.getElementById("nav-tex");
    const v = document.getElementById("view");

    if (!edEl || !graphEl || !semEl) return;
    if (!n1 || !n2 || !n3 ||!n4 || !v) return;

    this.tabbedPanel = new TabbedPanel(
      [n1,n2,n3,n4],
      v,
      "active"
    );
    const self = this;
    this.demo = createDemo(edEl, graphEl, semEl, function(
      h: string,
      mj: string,
      ml: string,
      l: string
    ) {
      self.tabbedPanel.setContent([h, mj, ml, l]);
      self.showDefaultHelpMessage();
    });

    this.showDefaultHelpMessage();
    this.setSample("a^{(2)}");

    (<any>window).highlightOk = this.highlightOk;
    (<any>window).highlightError = this.highlightError;
    (<any>window).highlightStr = this.highlightStr;
  }

  setNav(index: number) {
    this.tabbedPanel.setActiveTab(index);
  }

  highlightError(ids: number[], mes: string) {
    this.demo.highlight(ids, "highlight-error");
    this.showHelpMessage(mes, "rgba(244, 67, 54, 0.9)");
  }

  highlightOk(ids: number[]) {
    this.demo.highlight(ids, "highlight-frame");
    this.showDefaultHelpMessage();
  }

  highlightStr(ids: number[]) {
    this.demo.highlight(ids, "highlight-gray");
  }

  openExamplesMenu() {
    const el = document.getElementById("examples-menu");

    if (el) {
      el.classList.add("show");

      const closer = function() {
        const el2 = document.getElementById("examples-menu");
        if (el2) {
          el2.classList.remove("show");
        }
        document.removeEventListener("mouseup", closer);
      };

      document.addEventListener("mouseup", closer, false);
    }
  }

  setSample(tex: string) {
    this.demo.setSample(tex);
    this.demo.editor.focus();
  }

  showHelpMessage(mes: string, color: string) {
    const element = document.getElementById("help-message");
    if (element) {
      element.innerText = mes;
      element.style.color = color;
    }
  }

  showDefaultHelpMessage() {
    this.showHelpMessage(
      'Type "\\" to activate the context assistant',
      "rgb(108, 117, 125)"
    );
  }

  openVK() {
    showKeyboard(this.demo.editor);
  }
}
